<template>
    <edit></edit>
</template>

<script>
    import edit from './activity_presell_edit.vue'

    export default {
        name: 'activity_presell_add',

        components: {
            edit
        }
    }
</script>